import Control from 'ol/control/Control.js';
import Geolocation from 'ol/Geolocation.js';
import Point from 'ol/geom/Point.js';
import Feature from 'ol/Feature.js';
import {Vector as VectorLayer} from 'ol/layer.js';
import {Vector as VectorSource} from 'ol/source.js';
import {Circle as CircleStyle, Fill, Stroke, Style} from 'ol/style.js';

class CenterViewControl extends Control {
  constructor(opt_options) {
    const options = opt_options ? opt_options : {};

    const button = document.createElement('button');
    button.addEventListener('click', () => {
      this.setActive(!this.active);
    });

    const element = document.createElement('div');
    element.className = 'center-view-control ol-unselectable ol-control';
    element.title = 'Centrer la carte sur ma position';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    this.button = button;
    this.className = 'toggle glyphicon glyphicon-screenshot';
    this.position = undefined;
    this.catchDrag = true;
    this.setActive(options.active || false);
  }

  centerView() {
    if (this.position === undefined) {
      return;
    }
    this.catchDrag = false;
    this.getMap().getView().setCenter(this.position);
    this.catchDrag = true;
  }

  setActive(active) {
    this.button.className = this.className + (active ? ' active' : '');
    this.active = active;
    if (this.active) {
      this.centerView();
    }
  }

  setMap(map) {
    super.setMap(map);

    this.geolocation = new Geolocation({
      tracking: true,
      trackingOptions: {
        enableHighAccuracy: true,
      },
      projection: this.getMap().getView().getProjection(),
    });

    this.geolocation.on('change', () => {
      this.onPositionChange();
    });

    this.getMap()
      .getView()
      .on('change:center', () => {
        if (this.catchDrag) {
          this.setActive(false);
        }
      });
    this.catchDrag = true;

    this.positionFeature = new Feature();
    this.positionFeature.setStyle(
      new Style({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({
            color: '#3399CC',
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 2,
          }),
        }),
      })
    );
    this.geolocation.on('change:position', () => {
      var coordinates = this.geolocation.getPosition();
      this.positionFeature.setGeometry(coordinates ? new Point(coordinates) : null);
    });

    this.accuracyFeature = new Feature();
    this.geolocation.on('change:accuracyGeometry', () => {
      this.accuracyFeature.setGeometry(this.geolocation.getAccuracyGeometry());
    });

    this.layer = new VectorLayer({
      map: map,
      source: new VectorSource({
        features: [this.accuracyFeature, this.positionFeature],
      }),
    });

    this.setActive(this.active);
  }

  onPositionChange() {
    if (this.active) {
      this.position = this.geolocation.getPosition();
      this.centerView();
    }
  }
}

export default CenterViewControl;
